import { CustomRolesApi, UpdateCustomRoleDto } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { UseMutationOptions } from 'react-query/types/react/types';
import { getApiConfiguration } from '../../../common';

type UseUpdateCustomRole = (
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, UpdateCustomRoleMutationArgs>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, UpdateCustomRoleMutationArgs>;

export type UpdateCustomRoleMutationArgs = {
  id: string;
  updateCustomRoleDto: UpdateCustomRoleDto;
};

export const useUpdateCustomRole: UseUpdateCustomRole = (options) => {
  const customRolesApi = new CustomRolesApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;

  return useMutation(
    (args: UpdateCustomRoleMutationArgs) =>
      customRolesApi.updateCustomRole(tenantId, args.id, args.updateCustomRoleDto),
    options,
  );
};
